import { useCategory } from "../../../fetch/fetch.category.ts";
import ErrMessage from "../../core/ErrMessage.tsx";
import { EMPTY_CATEGORY } from "../../../const/typeDefault/Category.ts";
import Image from "../../core/image/Image";

const CategoryImage = ({
  slug,
  sizes,
  className,
  pureMode = false,
  size,
}: {
  slug: string;
  sizes?: string;
  className: string;
  pureMode?: boolean;
  size: number;
}) => {
  const { category, isLoading, isError } = useCategory(slug, EMPTY_CATEGORY);
  if (isLoading) {
    return <div className={`skeleton animate-pulse h-${size} w-${size}`}></div>;
  }
  if (isError) return <ErrMessage message={isError} />;
  if (!category.iconUrl) {
    return (
      <Image
        className={className}
        alt={`Bild von ${category.name}`}
        src="https://www.surfanzeigen.de/logo192.png"
        sizes={sizes}
        pureMode={pureMode}
        iconSize={size}
      />
    );
  }
  return (
    <Image
      className={className}
      alt={`Bild von ${category.name}`}
      src={category.iconUrl}
      sizes={sizes}
      pureMode={pureMode}
      iconSize={size}
    />
  );
};
export default CategoryImage;
